export default __webpack_public_path__ + "static/media/agent-role-scout-grey.a78b80b8.svg";